import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { AppInsightsContextProvider } from 'contexts/AppInsightsContext';
import { OnlineStatusContextProvider } from 'contexts/OnlineStatusContext';
import { AuthenticationContextProvider } from 'contexts/AuthenticationContext';
import { TranslationContextProvider } from 'contexts/TranslationContext';
import AppRoutes from './AppRoutes';
import './App.module.scss';

const App = ({ queryClient }: { queryClient: QueryClient }) => {
  return (
    <AppInsightsContextProvider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <OnlineStatusContextProvider>
            <TranslationContextProvider>
              <AuthenticationContextProvider>
                <AppRoutes />
              </AuthenticationContextProvider>
            </TranslationContextProvider>
          </OnlineStatusContextProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </AppInsightsContextProvider>
  );
};

export default App;
